module.exports = __webpack_public_path__ + "static/media/support.ad29b4e1.svg";